var _title, _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgVisualizationSelectionColumn = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 48 48",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "Icon / Visualization Selection / Column / Default")), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icon-/-Visualization-Selection-/-Column-/-Default"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Bounding-box",
  x: 0,
  y: 0,
  width: 48,
  height: 48
}), /*#__PURE__*/React.createElement("g", {
  id: "Icon",
  fill: "#81848F"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2 46h46v2H0V0h2z",
  id: "Axes"
}), /*#__PURE__*/React.createElement("g", {
  id: "Columns",
  transform: "translate(6.000000, 4.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 18h10v20H0zM14 0h10v38H14zm14 8h10v30H28z"
})))))));
export default SvgVisualizationSelectionColumn;